import React, {useState, useEffect} from "react";
import ResponsiveBox, {
    Row,
    Col,
    Item,
    Location,
} from 'devextreme-react/responsive-box';
import Box from 'devextreme-react/box';
import RecogResultInfoDatagrid from "./RecogResultInfoDatagrid";
import RecogResultCropFooter from "./RecogResultCropFooter";
import config from './Config.js';

export default function RecogResult({ data, isNewCropVersion }) {
    const [cropSelectedIdx, setCropSelectedIdx] = useState(0);
    const [cropItemData, setCropItemData] = useState({img:"", recogRate:0});
    function CropImageSelect(idx, regno) {
        if (cropSelectedIdx != idx) {
            setCropSelectedIdx(idx);
            getCropItemData(idx, regno);
        }
    }
    const getCropItemData = async (idx, regno) => {
        if (regno == -1) {
            let temp = {
                img: data[idx].recogImg,
                recogRate: data[idx].recogRate,
                recogResult: []
            };
            setCropItemData(temp);
        }
        else if (isNewCropVersion) {
            let temp = {
                img: data[idx].recogImg,
                recogRate: data[idx].recogRate,
                recogResult: data[idx].result
            }
            setCropItemData(temp);
        }
        else {
            let res = await fetch(`${config.apiUrl}/adminpage/detailpage/item?regno=${regno}`).then(res => res.json());
            await Promise.all(res.map((value, index) => {
                value.num = index + 1;
            }));
            let temp = {
                img: data[idx].recogImg,
                recogRate: `${Math.round(data[idx].recogRate)}%`,
                recogResult: res
            };
            setCropItemData(temp);
        }
    };

    useEffect(() => {
        setCropSelectedIdx(1);
        if (typeof data != "undefined" && data != null) {
            getCropItemData(1, data[1].regNo);
        }
    }, [data]);

    return(
            <ResponsiveBox>
                <Row ratio={15}></Row>
                <Row ratio={3}></Row>

                <Col ratio={6}></Col>
                <Col ratio={3}></Col>

                <Item>
                    <Location
                        row={0}
                        col={0}
                    ></Location>
                    <Box
                        direction="col"
                        width="100%"
                        height="100%"
                    >
                        <Item ratio={1}>
                            <Box
                                height="100%"
                                crossAlign="center"
                            >
                                <Item ratio={1}>
                                    <a>미리보기</a>
                                </Item>
                            </Box>
                        </Item>
                    <Item ratio={25}>
                        <img src={cropItemData.img}
                                width="100%"
                                height="100%"
                                style={{
                                    objectFit: "contain",
                                    borderWidth: 1,
                                    borderStyle: "solid",
                                    borderColor: "#3cbab2"
                                }}
                                />
                        </Item>
                    </Box>
                </Item>
                <Item>
                    <Location
                        row={0}
                        col={1}
                    ></Location>
                    <Box
                        direction="col"
                        width="100%"
                        height="100%"
                        crossAlign="center"
                    >
                        <Item ratio={1}>
                            <Box
                                direction="col"
                                width="29vw"
                                height="100%"
                            >
                                <Item ratio={1}>
                                    <Box
                                        height="100%"
                                        crossAlign="center"
                                    >
                                        <Item ratio={1}>
                                            <a>해석결과정보</a>
                                        </Item>
                                    </Box>
                                </Item>
                                <Item ratio={24}>
                                    <Box
                                        direction="col"
                                        width="100%"
                                        height="100%"
                                        style={{
                                            borderWidth: 1,
                                            borderStyle: "solid",
                                            borderColor: "#3cbab2"
                                        }}
                                    >
                                    <Item ratio={1}>
                                        <RecogResultInfoDatagrid dataSource={cropItemData.recogResult} />
                                        </Item>
                                    </Box>
                                </Item>
                                <Item ratio={1}>
                                    <Box
                                    direction="row"
                                    width="100%"
                                    height="100%"
                                    style={{
                                        backgroundColor: "lightgray",
                                        borderWidth: 1,
                                        borderStyle: "solid",
                                        borderColor: "#3cbab2"
                                    }}
                                    >
                                        <Item ratio={3}>
                                            <Box
                                                height="100%"
                                                crossAlign="center"
                                                style={{
                                                    borderWidth: 1,
                                                    borderStyle: "solid",
                                                    borderTop: "none",
                                                    borderColor: "#3cbab2"
                                                }}
                                            >
                                                <Item ratio={1}>
                                                    <a
                                                        align="center"
                                                        style={{
                                                            fontSize: "large"
                                                        }}
                                                    >인식율</a>
                                                </Item>
                                            </Box>
                                        </Item>
                                        <Item ratio={7}>
                                            <Box
                                                height="100%"
                                                crossAlign="center"
                                                style={{
                                                    borderWidth: 1,
                                                    borderStyle: "solid",
                                                    borderTop: "none",
                                                    borderColor: "#3cbab2"
                                                }}
                                            >
                                                <Item ratio={1}>
                                                    <a
                                                        align="center"
                                                        style={{
                                                            fontSize: "large"
                                                    }}
                                                >{cropItemData.recogRate}</a>
                                                </Item>
                                            </Box>
                                        </Item>
                                    </Box>
                                </Item>
                            </Box>
                        </Item>
                    </Box>
                </Item>
                <Item>
                    <Location
                        row={1}
                        col={0}
                        colspan={2}
                    ></Location>
                    <Box
                        direction="col"
                        width="89.5vw"
                        height="100%"
                    >
                    <Item ratio={1}>
                        <RecogResultCropFooter data={data} clickFunction={CropImageSelect} />
                        </Item>
                    </Box>
                </Item>
            </ResponsiveBox >
        );
}
